import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import Bannerfrom from "../components/bannerfrom";
import { Link } from "gatsby";

function Banner(props) {
  return (
    <div className="services_location_banner">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={7} xxl={7} className="my-auto">
            <div className="banenr_content">
              <div className="example" data-text="Florida">
                <h1>Hire Top Mobile App Developer in Florida</h1>
              </div>
              <p className="main_para">
                TekRevol is a trusted mobile app development agency in Florida.
                We have worked with multiple businesses from different
                industries, and took their operations to the next level. Our
                pledge is to deliver scalable and distinct mobile app
                development services for your business growth utilizing novel
                technologies and tools.
              </p>
              <Link
                to="/contact"
                className="border_btn dark_btns"
                aria-label="TekRevol Contact"
              >
                Let’s Get Started
              </Link>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={5} xxl={5} className="my-auto">
            <Bannerfrom />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
